import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconFileListTimes: React.FC<Props> = ({
  width = 24,
  height = 24,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.75 5V2.75L17.25 7.25H15C13.42 7.25 12.75 6.58 12.75 5ZM12.74 19.6C12.8 19.8 12.66 20 12.46 20H6C4 20 3 19 3 17V5C3 3 4 2 6 2H11.25V5C11.25 7.42 12.58 8.75 15 8.75H18V12.21C18 12.37 17.87 12.5 17.71 12.51C14.82 12.66 12.5 15.07 12.5 18C12.5 18.56 12.58 19.1 12.74 19.6ZM7.75 15C7.75 14.586 7.414 14.25 7 14.25C6.586 14.25 6.25 14.586 6.25 15C6.25 15.414 6.586 15.75 7 15.75C7.414 15.75 7.75 15.414 7.75 15ZM7.75 11C7.75 10.586 7.414 10.25 7 10.25C6.586 10.25 6.25 10.586 6.25 11C6.25 11.414 6.586 11.75 7 11.75C7.414 11.75 7.75 11.414 7.75 11ZM11.75 15C11.75 14.586 11.414 14.25 11 14.25H9.5C9.086 14.25 8.75 14.586 8.75 15C8.75 15.414 9.086 15.75 9.5 15.75H11C11.414 15.75 11.75 15.414 11.75 15ZM14 11.75C14.414 11.75 14.75 11.414 14.75 11C14.75 10.586 14.414 10.25 14 10.25H9.5C9.086 10.25 8.75 10.586 8.75 11C8.75 11.414 9.086 11.75 9.5 11.75H14ZM22 18C22 20.209 20.209 22 18 22C15.791 22 14 20.209 14 18C14 15.791 15.791 14 18 14C20.209 14 22 15.791 22 18ZM18.707 18L19.353 17.354C19.548 17.159 19.548 16.842 19.353 16.647C19.158 16.452 18.841 16.452 18.646 16.647L18 17.293L17.354 16.647C17.159 16.452 16.842 16.452 16.647 16.647C16.452 16.842 16.452 17.159 16.647 17.354L17.293 18L16.647 18.646C16.452 18.841 16.452 19.158 16.647 19.353C16.745 19.451 16.873 19.499 17.001 19.499C17.129 19.499 17.257 19.45 17.355 19.353L18.001 18.707L18.647 19.353C18.745 19.451 18.873 19.499 19.001 19.499C19.129 19.499 19.257 19.45 19.355 19.353C19.55 19.158 19.55 18.841 19.355 18.646L18.707 18Z"
      fill={color}
    />
  </svg>
);

export default IconFileListTimes;
